import React, { useMemo, useState } from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import { JobApplication } from './jobApplication';

export const JobApplications = ({ jobApplications = [], contactId }) => {
  const applications = useMemo(
    () =>
      jobApplications.map((application) => ({
        id: application.id.toString(),
        jobTitle: application.job.title,
        company: application.job.organization.name,
        networkLogoColor: null,
        applicationDate: application.createdAt,
        jobBoardLogo: application.collection.logoUrl,
        jobBoard: application.collection.name,
        firstName: application.firstName,
        lastName: application.lastName,
        email: application.email,
        linkedinUrl: application.linkedinUrl,
        website: application.profileUrl,
        resumeUrl: application.cvUrl,
        authorizedToWork: application.usWorkAuthorization,
        requiresVisa: application.usVisaSponsorship,
        additionalInfo: application.additionalInfo,
        contactId,
      })),
    [jobApplications, contactId],
  );

  const [expandedId, setExpandedId] = useState(null);

  const handleToggle = (applicationId) => {
    setExpandedId(expandedId === applicationId ? null : applicationId);
  };

  return (
    <Flex sx={{ flexDirection: 'column', gap: '16px', mt: '40px' }}>
      <Flex
        sx={{
          gap: '8px',
          flexDirection: 'column',
        }}
      >
        <Text
          sx={{
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '500',
            color: 'text.dark',
          }}
        >
          Job applications
        </Text>
        {applications.length === 0 && (
          <Text
            sx={{
              color: 'text.subtle',
              fontFamily: 'Silka',
              fontSize: '14px',
              fontStyle: 'italic',
              fontWeight: '400',
              lineHeight: '140%',
              py: '8px',
            }}
          >
            This user has not applied to any job on your job board.
          </Text>
        )}
      </Flex>
      {applications.length > 0 && (
        <Box
          sx={{
            borderRadius: '8px',
            overflow: 'hidden',
          }}
        >
          {applications.map((application) => (
            <JobApplication
              key={application.id}
              application={application}
              isExpanded={expandedId === application.id}
              onToggle={() => handleToggle(application.id)}
            />
          ))}
        </Box>
      )}
    </Flex>
  );
};

JobApplications.propTypes = {
  jobApplications: PropTypes.array,
  contactId: PropTypes.string,
};

JobApplications.defaultProps = {
  jobApplications: [],
  contactId: '',
};
